import { render, staticRenderFns } from "./input-checkbox.vue?vue&type=template&id=3cb0208f&"
import script from "./input-checkbox.component.ts?vue&type=script&lang=ts&"
export * from "./input-checkbox.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports